import React from 'react';
import { Admin, Resource } from 'react-admin';
import { CityList, CityEdit, CityCreate } from './components/city/cities';
import { CityAdminList, CityAdminEdit, CityAdminCreate } from './components/users/city_admin_users';
import { MerchantAdminList, MerchantAdminEdit, MerchantAdminCreate } from './components/users/merchant_admin_users';
import { MerchantList, MerchantCreate, MerchantEdit } from './components/merchants/merchants';
import { CategoryList, CategoryCreate, CategoryEdit } from './components/categories/categories';
import { ProductList, ProductCreate, ProductEdit } from './components/products/products';
import { DeliveryAreaList, DeliveryAreaCreate, DeliveryAreaEdit } from './components/delivery_area/delivery_area';
import { UserList } from './components/users/users';
import { FeedbackList } from './components/feedbacks/feedbacks';
import { CityOrderList } from './components/orders/city_orders';
import { MerchantOrderList } from './components/orders/merchant_orders';
import { CouponList, CouponEdit, CouponCreate } from './components/coupons/coupons';
import Dashboard from './components/dashboard/dashboard';
import authClient from './utils/authClient';
import myRestClient from './utils/restClient';
import changeUrlPrefixToValue from './utils/urlDecorator';
import Login from './layout/Login';
import Layout from './layout/Layout';

import Menu from './layout/Menus';

const App = () => (
    <Admin dataProvider={changeUrlPrefixToValue(myRestClient)}
        title="Zadish Admin"
        authProvider={authClient}
        dashboard={Dashboard}
        loginPage={Login}
        appLayout={Layout}
        menu={Menu}>

        <Resource name="cities"
            list={CityList}
            edit={CityEdit}
            create={CityCreate} />

        <Resource name="city-admin-users"
            list={CityAdminList}
            edit={CityAdminEdit}
            create={CityAdminCreate} />

        <Resource name="ct/merchants"
            list={MerchantList}
            edit={MerchantEdit}
            create={MerchantCreate} />

        <Resource name="ct/delivery-areas"
            list={DeliveryAreaList}
            edit={DeliveryAreaEdit}
            create={DeliveryAreaCreate} />

        <Resource name="coupons"
            list={CouponList}
            edit={CouponEdit}
            create={CouponCreate} />

        <Resource name="mrcht/users"
            list={MerchantAdminList}
            edit={MerchantAdminEdit}
            create={MerchantAdminCreate} />

        <Resource name="mrcht/orders"
            list={MerchantOrderList} />

        <Resource name="mrcht/categories"
            list={CategoryList}
            edit={CategoryEdit}
            create={CategoryCreate} />

        <Resource name="mrcht/products"
            list={ProductList}
            edit={ProductEdit}
            create={ProductCreate} />

        <Resource name="app-users"
            list={UserList} />

        <Resource name="ct/orders"
            list={CityOrderList} />

        <Resource name="feedbacks"
            list={FeedbackList} />
    </Admin>
);

export default App;